import React, {useEffect, useState} from "react";
import styles from "../assets/css/blogs.module.scss";
import {Card, Collapse, Container, Grid, Hidden, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import Button3 from "../components/subComponents/Button3";
import Pagination from "../components/subComponents/Pagination";
import {NewsApi} from "../utils/NewsApi";
import configs from '../utils/config.json';
import Tab from "../components/Tab";
import Tabs from "../components/Tabs";
import {CategoryApi} from "../utils/CategoryApi";

const Blogs = (props) => {
    const [expanded, setExpanded] = useState(false);
    const [array, setArray] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [page, setPage] = useState(1);
    const [value, setValue] = React.useState();
    const [categories, setCategories] = useState([])
    const handleChange = (event, newValue) => {
        setValue(newValue);
        setPage(1);
    };
    const fetchData = async () => {
        if (value)
            await CategoryApi.get(value, page,
                ({data}) => {
                    setArray(data.news)
                    let pC = Math.floor(parseInt(data.news_count) / 10);
                    if (parseInt(data.news_count) % 10)
                        pC++;
                    setPageCount(pC);
                },
                (error) => {

                });

    }


    const fetchCategories = async () => {

        const response = ({data}) => {
            setCategories(data);
            if (data.length) {
                setValue(data[0].id)
            }
        }

        const error = (e) => {
            setCategories([]);
        }

        await CategoryApi.getAll(response, error);
    }
    useEffect(() => {
        window.scrollTo(0, 0);
        (async () => {
            await fetchCategories();
        })();
    }, []);

    useEffect(() => {
        (async () => {
            await fetchData();
        })();
    }, [value, page]);


    return <div>

        <div className={styles.firstContainer}>
            <Container maxWidth={"lg"}>


                <div style={{marginTop: 120, marginBottom: 50}}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="styled tabs example"
                    >
                        {categories.map((category, index) => <Tab key={index} label={category.name}
                                                                  value={category.id}/>)}

                    </Tabs>

                </div>


                <FirstItem {...array[0]}/>
            </Container>
        </div>


        <div className={styles.secondContainer}>
            <Container maxWidth={"lg"}>
                <Grid container>
                    {array.slice(1, 4).map((item, index) => <Grid item xs={12} md={4}>
                        <Item {...item}/>
                    </Grid>)}
                </Grid>
                {!expanded && <div className={styles.buttonContainer}>
                    <Button3 variant="text" onClick={e => {
                        setExpanded(true);
                    }}>دیدن اخبار بیشتر</Button3>
                </div>}
                <Collapse in={expanded}>
                    <>
                        <Grid container>
                            {array.slice(4).map((item, index) => <Grid item xs={12} md={4}>
                                <Item {...item}/>
                            </Grid>)}
                        </Grid>
                        <div className={styles.pagination}>
                            <Pagination count={pageCount} variant="outlined" color="primary"
                                        page={page}
                                        onChange={(event, value) => {
                                            setPage(value)

                                        }}/>

                        </div>
                    </>

                </Collapse>
            </Container>
        </div>
    </div>;
};

export default Blogs;

const FirstItem = (props) => {
    return <div>
        <Link to={`/blog/${props.id}`} className={styles.link2}>
            <Grid container>
                <Grid item xs={12} md={8}>
                    <img src={`${configs.server.Storage}/${props.img}`} alt={""}/>
                </Grid>
                <Grid item xs={12} md={4}>
                    <div className={styles.titleContainer}>
                        <Typography variant={"h6"} component={"h6"}>
                            {props.title}
                        </Typography>

                        <Typography variant={"subtitle2"} component={"p"} style={{textAlign: "justify"}}>
                            {props.description}
                        </Typography>
                    </div>
                </Grid>
            </Grid>
        </Link>
    </div>
}


const Item = (props) => {
    return <>

        <Hidden mdUp>
            <Link to={`/blog/${props.id}`} style={{display: "flex", marginTop: 15}} className={styles.link2}>
                <Card elevation={11} style={{display: "flex", width: "100%", background: "rgb(34, 40, 47)"}}>
                    <img src={`${configs.server.Storage}/${props.img}`} alt={""} style={{width: "35%", height: 200}}/>
                    <div style={{width: "65%", padding: 15}}>
                        <Typography variant={"h6"} component={"h4"} style={{color: "#fff"}}>
                            {props.title}
                        </Typography>
                        <Typography variant={"subtitle2"} component={"p"} style={{
                            textAlign: "justify",
                            color: "#fff",
                            maxHeight: 170,
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden"
                        }}>
                            {props.description}
                        </Typography>
                    </div>
                </Card>
            </Link>
        </Hidden>
        <Hidden mdDown>

            <Link to={`/blog/${props.id}`} className={styles.link2}>
                <Card elevation={11} className={styles.item}>

                    <img src={`${configs.server.Storage}/${props.img}`} alt={""}/>
                    <Typography variant={"h6"} component={"h4"}>
                        {props.title}
                    </Typography>

                    <Typography variant={"subtitle2"} component={"p"} style={{textAlign: "justify"}}>
                        {props.description}
                    </Typography>

                </Card>
            </Link>

        </Hidden>
    </>


};